import Extend from 'flarum/common/extenders';
import Tag from 'ext:flarum/tags/common/models/Tag';
export default [new Extend.Model(Tag) //
.attribute('richExcerpts').attribute('excerptLength').attribute('excerptMediaMaxHeight').attribute('excerptVideoMaxWidth').attribute('excerptMediaCount')];